<template>
  <div>

    <!-- ADD -->
    <!--<button
      type="button"
      v-on:click="CallModalTable()"
      class="btn-add-group-note"
    >
      <span class="add-icon">+</span>
      Add patient
    </button>


    GROUP NOTES LIST -->
    <a
      class="group-notes-list-link group-note-row"
      @click="GotoList()"
    >
      <span class="group-note-text">
        Log Note List
      </span>
    </a>


    <!-- PATIENT ITEMS -->
    <div class="group-note-item">

      <a class="hidden" style="display: none;"><span class="group-note-text"></span></a>
      <a :class="{'text-truncate': true,'isDisabled': itemdisabled, rmActiveItem: active_el == it.recordId.trim(),'rm-optionsuserM': true,'group-note-row': true}"
        v-for="it in this.ItemsList.patientNodes" :key="it.recordId + '-' + it.isNew" @click="triggerClick(it)">

        <span class="group-note-text">
          <span :class="{'ikon': true,'med-status-complete text-success': it.isNew == false }"></span>
          {{ it.patientName }}
        </span>

       <!-- <button type="button" class="btn-delete-item" title="Eliminar" @click="remove(it)" @click.stop>×</button>-->
      </a>

    </div>




    <!-- OPTIONS -->
    <small>
      {{ $t('GroupNotesItemRightBar.OptionMenu') }}
    </small>


    <!--<ModalTablePaginationClient
            v-bind:Resource="this.ResourceParameter" v-bind:TypeOption="this.TypeOption"
            @getCodeConditionOK="onCodeConditionOk($event)" @getCodeConditionCancel="onCodeConditionCancel($event)"
            v-bind:Fields="this.modalFields"  v-bind:FieldCode="this.fieldCode"
            v-bind:FieldDescription="this.fieldDescription" v-bind:TitleWindow="$t('schedule-editor.FindPatient')"
            v-bind:ModalId="this.modalId"  v-bind:AuxFields="this.AuxFields"  v-bind:FieldsDate="this.fieldsDate"
			v-bind:ReturnAll="true"
        >
		<template v-if="$slots.body" v-slot:body>
                <slot name="body" />
            </template>
        </ModalTablePaginationClient>-->

  </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import { EventBus } from '@/event-bus.js';
import DBFunctions from '@/common/DBFunctions.js'

export default {
  name: 'lognotenurseitemrightbar',
  mixins: [ShowMessage, DBFunctions],
 data() {
    return{
        AdmissionRecIdMultiple:null,
        PatientCodeMultiple:null,
        lastRecordId: null,
        ItemsList: {
         'patientNodes': [/*
            {
            "headerId":"A6D1DAAAB6FAD9FC",
            "notesId":null,
            "patientCode":"2306679",
            "patientName":"Mary Stomb",
            "dob":"06/14/2016",
            "sex":"F",
            "recordId":"459816087300579",
            "programCode":"ARU",
            "programName":"AUTISM REINTEGRATION UNIT / LICENSE 32029",
            "dateFrom":"11/20/2025",
            "dateTo":null,
            "chartno":"30",
            "activityId":"",
            "facilityCode":"WAIV",
            "isNew":false,
            "isChecked":false,
            "isVoid":false,
            "selected":true
            },
            {"headerId":"BBCF16D96045FB75","notesId":null,"patientCode":"1800051","patientName":"Alex Alvey","dob":"02/07/2003","sex":"M","recordId":"456863975730908","programCode":"ARU","programName":"AUTISM REINTEGRATION UNIT / LICENSE 32029","dateFrom":"01/29/2025","dateTo":null,"chartno":"18","activityId":"","facilityCode":null,"isNew":true,"isChecked":false,"isVoid":false,"selected":true}
        */],
         'groupNode': {},
         'patientFilters': []
        },

        AuxFields: [
				"patientName",
				"programCode",
                "programName",
				"patientCode",
				"recordId",
				"status",
				"dob"
			],
            fieldsDate: ["dob"],
            modalFields: [
				{
					key: "patientName",
					sortable: true,
					label: this.$t('Shared.PatientName'),
					class: "text-rigth",
				},
				{
					key: "patientCode",
					sortable: true,
					label: this.$t('Shared.PatientCode'),
					class: "text-rigth",
				},
				{ key: "dob", sortable: true, label: this.$t('Shared.Dob'), class: "text-rigth" },
                { key: "recordId", sortable: true, label: 'recId', class: "text-rigth hidden" },
				{
					key: "programName",
					sortable: true,
					label: this.$tc('Shared.Program', 1),
					class: "text-rigth",
				},


				{
					key: "status",
					sortable: true,
					label: this.$t('Shared.Status'),
					class: "text-rigth",
				},
			],
        Class:'',
        ResourceParameter: "",
        modalId: "ef-ModalIdLogNotesModalAddPatient",
        itemdisabled: false,
        PatientCode: '',
        aNoteName: "",
        TypeOption: "",
        fieldCode: "patientCode",
		fieldDescription: "patientName",
        refCode: "PatientName",
        ItemsListAuthorized: [],
        parameter: {
          UserId: "",
        },
        active_el: '',
        message: this.$t('Layout.displayedScreen'),
        patient: '',
        pendingChanges: false,
    }
  },

  computed: {
    patientNodesFiltered() {
        return this.searchInMenuItems(
            this.ItemsList.patientNodes,
            this.patient,
            'patientName'
        );
    }
},

  methods: {

      GotoList(){
        this.$router.push({name: "logNotesNurseList"});
      },

      remove(item){
        this.ItemsList.patientNodes = this.ItemsList.patientNodes.filter(x => x.recordId !== item.recordId);
      },

      savingChanges(item) {
        EventBus.$emit('SaveFromLogNotes',item,'')
      },

      /*goToNote(item) {

        this.AdmissionRecIdMultiple = item.recordId;
        this.PatientCodeMultiple = item.patientCode;

        let isGroupNote = item.headerID ? true :false
        this.active_el = isGroupNote ? item.headerID : item.patientCode?.trim() || "";

        EventBus.$emit('onPatientClickLogNotes', item.patientCode);
        EventBus.$emit('onPatientClickLogNoteEnableForm',true);
        EventBus.$emit('onClickPatientLogNoteMultiple', { admissionrecid:item.recordId, patientcode:item.patientCode});

      },*/



    syncLists(current, previous) {

        // 1. Agregar los nuevos seleccionados
        current.forEach(item => {

            const exists = this.ItemsList.patientNodes.some(
                x => String(x.recordId) === String(item.recordId)
            );

            if (!exists) {
                item.isNew = true;
                this.ItemsList.patientNodes.push(item);
            }
        });

        // 2. Eliminar los que fueron deseleccionados
        previous.forEach(item => {

            const stillSelected = current.some(
                x => String(x.recordId) === String(item.recordId)
            );

            if (!stillSelected) {
                this.ItemsList.patientNodes =
                    this.ItemsList.patientNodes.filter(
                        x => String(x.recordId) !== String(item.recordId)
                    );
            }
        });
    },
/*
    syncLists(current, previous) {

    // 1. Agregar los nuevos pacientes seleccionados
    current.forEach(item => {

        const exists = this.ItemsList.patientNodes.some(
            x => String(x.patientCode).trim() === String(item.patientCode).trim()
        );

        if (!exists) {
            item.isNew = true;
            this.ItemsList.patientNodes.push(item);
        }
    });

    // 2. Eliminar los pacientes que ya no tienen ninguna selección
    previous.forEach(item => {

        const stillSelected = current.some(
            x => String(x.patientCode).trim() === String(item.patientCode).trim()
        );

        if (!stillSelected) {
            this.ItemsList.patientNodes =
                this.ItemsList.patientNodes.filter(
                    x => String(x.patientCode).trim() !== String(item.patientCode).trim()
                );
        }
    });
},*/

    goToNote(item) {
        this.AdmissionRecIdMultiple = item.recordId;
        this.PatientCodeMultiple = item.patientCode;

       // let isGroupNote = item.headerID ? true : false;
        //this.active_el = isGroupNote ? item.headerID : item.patientCode?.trim() || "";
        this.active_el = item.recordId;

        if (this.lastRecordId === item.recordId) {
            return;
        }

        if (this.lastRecordId !== null) {
            EventBus.$emit('onAutoSaveLogNote', this.lastRecordId);
        }

        this.lastRecordId = item.recordId;
        EventBus.$emit('onPatientClickLogNoteEnableForm');
        EventBus.$emit('onPatientClickLogNotes', item.patientCode);
        console.log(item);
        EventBus.$emit('onClickPatientLogNoteMultiple', {admissionrecid: item.recordId,patientcode: item.patientCode});

    },

      triggerClick: function (item){
          if (this.pendingChanges) {
          this.savingChanges(item)
        } else {
          this.goToNote(item)
        }
      },

      CallModalTable: async function () {
			this.FieldsParameter = [this.fieldCode, this.fieldDescription];
			this.ResourceParameter = "/PatientRegistrations/Table?useEmployeeRestriction=true";
			this.TypeOption = this.refCode;
			this.$bvModal.show(this.modalId);
		},

        onCodeConditionCancel() {
			this.ResourceParameter = "";
			this.$bvModal.hide(this.modalId);
		},


        onCodeConditionOk(result) {

           /* result.forEach(patient => {
                 patient.isNew = true;
                 this.ItemsList.patientNodes.push(patient);
            })*/

            result.forEach(patient => {
                const exists = this.ItemsList.patientNodes.some(
                    x => String(x.recordId) === String(patient.recordId)
                );

                if (!exists) {
                    patient.isNew = true;
                    this.ItemsList.patientNodes.push(patient);
                }
            });


			/*result.forEach(patient => {

				let patientItem = {
				headerId: patient.headerId,
				patientCode: patient.patientCode,
				patientName: patient.patientName,
				admissionRecordId: patient.admissionRecordId,
				chartno: patient.chartno,
				dateFrom: patient.dateFrom,
				dateTo: patient.dateTo,
				dob: patient.dob,
				facilityCode: patient.facilityCode,
				isChecked: patient.isChecked,
				activityId: patient.activityId,
				isNew: patient.isNew,
				programName: patient.programName,
				programCode: patient.programCode,
				isVoid: patient.isVoid,
				sex: patient.sex
			}

			let selected = this.items.find(el => el.patientCode === patientItem.patientCode)

			if (!selected) {
				this.items.push(patientItem)
				this.$set(patientItem, 'selected', true);
				//EventBus.$emit('onInsertPatient', patientItem);
				//this.insertAPatient(patientItem.patientCode, patientItem.admissionRecordId, patientItem.activityId)
				this.SelectedRecords++;
				this.totalRows = this.SelectedRecords
			} else {
				this.showMessage(this.$tc('Msg.Warning'), this.$t('GroupNotesAccordion.msgAlready'), "warning");
			}
			});*/

			this.$bvModal.hide(this.modalId);
		},

    updateIsNew(recordId, value) {
        const index = this.ItemsList.patientNodes.findIndex(x => String(x.recordId) === String(recordId));
        if (index !== -1) {
            const item = {...this.ItemsList.patientNodes[index],isNew: value
        };
        this.$set(this.ItemsList.patientNodes, index, item);
    }
}




  },


  updated(){
    this.itemdisabled = this.$attrs.itemdisabled;
    this.PatientCode = this.$attrs.PatientCode;
  },

  beforeCreate(){
    this.itemdisabled = this.$attrs.itemdisabled;
    this.PatientCode = this.$attrs.PatientCode;
  },

  async mounted() {
    this.itemdisabled = this.$attrs.itemdisabled;
    this.PatientCode = this.$attrs.PatientCode;
  },

  created(){
    EventBus.$on("onLNSearchPatient", function (value) {
      this.patient = value
    }.bind(this));

    EventBus.$on("onPatientClickLogNotesSave", function (item) {
        console.log(item);
        this.updateIsNew(item,false);
    }.bind(this));

    EventBus.$on("onUpdateLogNotesPatientNodes", function (data) {
        this.syncLists(data.current, data.previous);
    }.bind(this));




  },

  destroyed(){
    EventBus.$off('onUpdateLogNotesPatientNodes');
    EventBus.$off('onLNSearchPatient');
    EventBus.$off('onPatientClickLogNotesSave');
}
};
</script>

<style>
.isDisabled {
  cursor: not-allowed!important;
  opacity: 0.5!important;
}
.isDisabled > a {
  color: currentColor!important;
  display: inline-block!important;  /* For IE11/ MS Edge bug */
  pointer-events: none!important;
  text-decoration: none!important;
}
.rmActiveItem {
  background-position: -230px !important;
  color: #FFF !important;
}

.itemGroupNote{
    width: 230px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.group-notes-menu {
  width: 100%;
}

/* -------------------------
   HEADER
------------------------- */

.group-notes-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 8px;
  margin-bottom: 5px;
  background: #f7f7f7;
  border: 1px solid #eeeeee;
  min-height: 36px;
}

.group-notes-list-link {
  color: #808080;
  font-size: 12px;
  text-decoration: none;
  cursor: pointer;
}

.group-notes-list-link:hover {
  color: #008fc5;
}


/* -------------------------
   ADD BUTTON
------------------------- */

.btn-add-group-note {
  border: 0 !important;
  border-radius: 10px 10px 0 0 !important;
  background: linear-gradient(180deg, #008fc5CC, #008fc5 20%, #008fc5 70%, #008fc500) !important;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  padding: 6px 10px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.btn-add-group-note:hover {
  background: linear-gradient(180deg, #007da9, #007da9 80%, #007da900) !important;
}

.btn-add-group-note:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 143, 197, 0.15);
}

.add-icon {
  font-size: 15px;
  font-weight: bold;
  margin-right: 3px;
  vertical-align: -1px;
}









/* =========================================
   GROUP NOTE ROW
========================================= */

.group-note-row {
  display: flex !important;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  text-decoration: none !important;
}


/* =========================================
   TEXT
========================================= */

.group-note-text {
  display: flex;
  align-items: center;

  min-width: 0;
  flex: 1;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}


/* =========================================
   DELETE BUTTON
========================================= */

.btn-delete-item {
  flex: 0 0 auto;

  width: 22px;
  height: 22px;

  margin-left: 8px;
  margin-right: 2px;

  padding: 0;

  border: none;
  border-radius: 50px;

  background: #ffffff;
  color: #999999;

  font-size: 17px;
  font-weight: 400;
  line-height: 19px;

  text-align: center;

  cursor: pointer;

  transition: all 0.15s ease;
}


/* Hover del Delete */
.btn-delete-item:hover {
  background: #fdf0f0;
  border-color: #e2a5a5;
  color: #d9534f;

  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}


/* Click */
.btn-delete-item:active {
  background: #f9dddd;
  transform: scale(0.95);
}


/* Focus */
.btn-delete-item:focus {
  outline: none;
}


/* =========================================
   ADD BUTTON
========================================= */

.btn-add-group-note {
  float: right;

  margin: 4px 5px 6px 0;

  border: 1px solid #008fc5;
  border-radius: 3px;

  background: #008fc5;
  color: #fff;

  font-size: 11px;
  font-weight: 600;

  line-height: 1;

  padding: 6px 10px;

  cursor: pointer;

  transition: all 0.15s ease;
}

.btn-add-group-note:hover {
  background: #007da9;
  border-color: #007da9;

  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
}

.btn-add-group-note:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 143, 197, 0.15);
}

.add-icon {
  font-size: 15px;
  font-weight: bold;
  margin-right: 3px;
  vertical-align: -1px;
}


/* =========================================
   GROUP NOTES HEADER LINK
========================================= */

.group-notes-list-link {
  clear: both;

  color: #808080;
  font-size: 12px;
  cursor: pointer;

  padding: 5px 7px;
}

.group-notes-list-link:hover {
  color: #008fc5;
}


/* =========================================
   PATIENT ITEMS
========================================= */

.group-note-item > .group-note-row {
  padding-right: 5px;
}


/* =========================================
   ACTIVE ITEM
========================================= */

.rmActiveItem .btn-delete-item {
  background: rgba(255, 255, 255, 0.95);
  border-color: rgba(255, 255, 255, 0.8);
  color: #999999;
}

.rmActiveItem .btn-delete-item:hover {
  background: #fdf0f0;
  border-color: #e2a5a5;
  color: #d9534f;
}



</style>


